import React, { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faInfoCircle, faCog } from '@fortawesome/free-solid-svg-icons';
import schart from '../../assets/images/schart.png';
import shome from '../../assets/images/shome.png';
// import { useLocation } from "react-router-dom";
import { useAuth, useAuthRFS, useAuthULD, useAuthASR, useAuthHRFS, useAuthSAdmin, useAuthFULD, useAuthHSR } from '../../useAuth/useAuth';

const LeftMenu = ({ module, onTab, selectedTab }) => {
    const isAuthenticated = useAuth();
    const isAuthenticatedSAdmin = useAuthSAdmin();
    const isAuthenticatedRFS = useAuthRFS();
    const isAuthenticatedULD = useAuthULD();
    const isAuthenticatedASR = useAuthASR();
    const isAuthenticatedHSR = useAuthHSR();
    const isAuthenticatedHRFS = useAuthHRFS();
    const isAuthenticatedFULD = useAuthFULD();

    const location = useLocation();
    let navItems;
    if (isAuthenticated) {

    } else if (isAuthenticatedSAdmin) {
        navItems = [
            { name: 'OverView', path: '/BookingtruckSchedule', image: shome },
            { name: 'Organisation', path: '/TruckingDashboard', image: shome },
            { name: 'Suppoer Ticket', path: '/kpicharts', image: schart },
            { name: 'Module Update', path: '/kpicharts', image: schart },
            // Add more items with respective paths as needed
        ];
    } else if (isAuthenticatedRFS) {
        navItems = [
            { name: 'Home', path: '/BookingtruckSchedule', image: shome },
            { name: 'Dashboard', path: '/TruckingDashboard', image: shome },
            { name: 'Charts', path: '/kpicharts', image: schart },
            // Add more items with respective paths as needed
        ];
    } else if (isAuthenticatedULD) {
        navItems = [
            { name: 'Home', path: '/ULDControl', image: shome },
            { name: 'Charts', path: '/Charts', image: schart },
            { name: 'Stock Allotment', path: '/StockAllotment', image: schart },
            // { name: 'Charts', path: '/kpicharts', image: schart },
            // Add more items with respective paths as needed
        ];
    } else if (isAuthenticatedASR) {
        navItems = [
            { name: 'Home', path: '/ServiceRecovery', image: shome },
            { name: 'Charts', path: '/ServiceRecoveryCharts', image: schart },
            // { name: 'Charts', path: '/kpicharts', image: schart },
            // Add more items with respective paths as needed
        ];
    } else if (isAuthenticatedHSR) {
        navItems = [
            { name: 'Home', path: '/ServiceRecovery', image: shome },
            { name: 'Charts', path: '/ServiceRecoveryCharts', image: schart },
            // { name: 'Charts', path: '/kpicharts', image: schart },
            // Add more items with respective paths as needed
        ];
    } else if (isAuthenticatedHRFS) {
        navItems = [
            { name: 'Home', path: '/HandlerTruckMonitor', image: shome },
            { name: 'Dashboard', path: '/HandlerDashboard', image: schart },
            { name: 'Monitor', path: '/HandlerMonitor', image: schart },
            // { name: 'Charts', path: '/kpicharts', image: schart },
            // Add more items with respective paths as needed
        ];
    } else if (isAuthenticatedFULD) {
        navItems = [
            { name: 'Home', path: '/ULDForwarder/ActiveTrips', image: shome, tab: '' },
            { name: 'Charts', path: '/Charts', image: schart, tab: 'CH' },
            // Add more items with respective paths as needed
        ];
    }

    const navigate = (e, path) => {
        console.log('path', path);
        e.preventDefault()
        onTab(path)

    };


    return (
        <nav className="sidebar sidebar-offcanvas" id="sidebar">
            <ul className="nav">
                {navItems?.map((item) => {
                    const isActive = selectedTab === item.tab;
                    
                    return (
                        <li key={item.name}>
                            {module === 'UF' ?
                                <Link to='#' onClick={(e) =>navigate(e, item.tab)} className={`nav-link ${isActive ? 'active' : ''} rounded`}>
                                    {console.log("img", item.onClick)}
                                    <img src={item.image} /><span>{item.name}</span><span className="act-sign"></span>
                                </Link>
                                :
                                <Link to={item.path} className={`nav-link ${location.pathname === item.path ? 'active' : ''} rounded`}>
                                    <img src={item.image} /><span>{item.name}</span><span className="act-sign"></span>
                                </Link>
                            }
                        </li>
                    )
                })}
            </ul>
        </nav>
    );
}
export default LeftMenu;